<template lang="jade">
  .container-fluid
    .row
      .event_main.col-md-12
        header.event_titile_bar.main_title_bar.clearfix
          h1.title.col-md-12.col-sm-10.col-xs-12
            |{{!showGroupConfig ? 'event' : ' Email / SMS'}}
        .function_group.col-lg-12.clearfix.no_pad
          button.config_switch.col-lg-2.btn.btn-info.pull-right.clearfix(v-on:click='showGroupConfig = !showGroupConfig')
            |{{!showGroupConfig ? 'Edit Email/SMS group' : 'Back To Event'}}
        section.event_content.clear-left.clearfix(v-show='!showGroupConfig')
          table.table.table-bordered.table-striped.event_mobile_table.hidden-md.hidden-lg
            tr
              th No.
              th Name
              th
            tr(v-for="(key ,event) in events")
              td {{ key }}
              td {{ event.name }}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit
          table.table.table-bordered.table-striped.table-hover.event_table.hidden-sm.hidden-xs
            tr
              th Enabled
              th No.
              th Name
              th Event
              th Source
              th Actions
              th
            tr(v-for="(key, event) in events")
              td.enabled
                i.fa.fa-check-square.fa-lg(v-if='event.enabled' v-on:click='setEvent(false, key)')
                i.fa.fa-square-o.fa-lg(v-else v-on:click='setEvent(true, key)')
              td {{ key }}
              td {{event.name}}
              td {{ returnEventName(event.event) }}
              td.source
                .col-xs-12.col-centered(v-for='(key, source) in event.event.source')
                  span.clearfix(v-bind:data-bgColor='source') [DI{{source}}] {{DIs[source].name}}
              td.action
                span.action__single.clearfix(v-for="ac in event.actions")
                  label.action_title.pull-left {{actionTranslator(ac.action)}}:
                  span.action_content.pull-left.col_space--xxs.clearfix(v-for="target in ac.targets")
                    span.action_tags(v-if="ac.action === 'Email' || ac.action === 'SMS'") {{target}}
                    span.action_target(v-else v-bind:data-bgColor='target')
                      |[DO{{target}}]{{DOs[target].name}}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit.fa-lg
        section.group_editing_section.clear-left.clearfix(v-show='showGroupConfig')
          .col-xs-12.col-lg-10.col-centered.row_space--xxs
            tabs
              tab(header='Email')
                .col-md-12
                  table.table.table-striped.table-hover.table-bordered.email_group_table
                    tr
                      th No
                      th Group Name
                      th.hidden-xs.hidden-sm
                        |Emails
                      th
                    tr(v-for="(key, group) in emailData")
                      td {{key}}
                      td {{group.name}}
                      td.hidden-xs.hidden-sm
                        |{{group.accounts}}
                      td
                        i.fa.fa-edit.fa-lg(v-on:click="handleGroupConfig('email', key)")
              tab(header='SMS')
                .col-md-12
                  table.table.table-striped.table-hover.table-bordered.SMS_group_table
                    tr
                      th No
                      th Group Name
                      th.hidden-xs.hidden-sm
                        |Numbers
                      th
                    tr(v-for="(key, group) in SMSData")
                      td {{key}}
                      td {{group.name}}
                      td.hidden-xs.hidden-sm
                        |{{group.accounts}}
                      td
                        i.fa.fa-edit.fa-lg(v-on:click="handleGroupConfig('SMS', key)")
  modal.popout.event_config(
    v-bind:show.sync='showModal'
    v-bind:title='editing.title'
    effect='zoom'
    v-bind:callback='handleEventConfig'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-body(slot="modal-body")
      table.table.table-bordered.event_config_table
        tr
          th Enabled
          td
            .fa_checkbox
              input(type="checkbox" v-model="editing.newEvent.enabled" v-bind:id="'event' + editing.index")
              label(v-bind:for="'event' + editing.index")
                |Enabled
        tr
          th Name
          td
            validator(name='eventName')
              input.form-control(type="text" v-model="editing.newEvent.name" maxLength='7' v-validate:name="['engAndNum']")
              span.error(v-show='$eventName.name.invalid && $eventName.name.modified')
                |English characters , numbers and '_' only
        tr
          th Source
          td.source.col-xs-10
            v-bank(v-bind:options='sourceOptions'
                   name-prop='source_target'
                   v-bind:output.sync='editing.newEvent.newSource')
        tr
          th Event
          td
            span.col-xs-12.no_pad.event_content.key
              label Trigger type
              .col-xs-12.no_pad
                v-single-select(v-bind:options='eventOptions'
                              v-bind:value.sync='editing.newEvent.key'
                              placeholder='Please select a key')
            span.col-xs-12.no_pad.event_content.condition(v-if="editing.newEvent.key === 'DI'")
              label Condition
              //- .col-xs-12.no_pad
              //-   |{{editing.newEvent.condition}}
            span.col-xs-12.no_pad.event_content.power_value(v-if="editing.newEvent.key === 'DI'")
              .col-xs-12.no_pad
                v-single-select(v-bind:options='eventValueOptions'
                              v-bind:value.sync='editing.newEvent.value'
                              placeholder='Please select a value')
        tr
          th Actions
          td.actions
            span.col-xs-12.no_pad.row_space--xxs.clearfix.do_high
              .fa_checkbox
                input(type="checkbox" value='DO High' id="do_high" v-model='newActions' v-bind:checked.once="editing.actionKeys.indexOf('DO High') !== -1")
                label(for="do_high") DO High
              .bank_group
                v-multi-banks(v-bind:options='targetOptions'
                            v-bind:output-ary.sync='actions.high.targets'
                            name-prop='do_high_target'
                            v-bind:show-option="newActions.indexOf('DO High') !== -1")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.do_low
              .fa_checkbox
                input(type="checkbox" value='DO Low' id="do_low" v-model='newActions' v-bind:checked.once="editing.actionKeys.indexOf('DO Low') !== -1")
                label(for="do_low") DO Low
              .bank_group
                v-multi-banks(v-bind:options='targetOptions'
                            v-bind:output-ary.sync='actions.low.targets'
                            name-prop='do_low_target'
                            v-bind:show-option="newActions.indexOf('DO Low') !== -1")
            span.col-xs-12.no_pad.row_space--xxs.clearfix.email(v-if="emailGroups.options.length !== 0")
              .fa_checkbox
                input(type="checkbox" value='Email' id="email" v-model='newActions' v-bind:checked.once="editing.actionKeys.indexOf('Email') !== -1")
                label(for="email" v-on:click.prevent="clickGroups('Email')") email
              span.no_pad.col-xs-12.row_space--xxs(v-if="newActions.indexOf('Email') !== -1")
                  v-select(
                    v-bind:selected="emailGroups.selected",
                    v-bind:show-labels="true",
                    v-bind:options="emailGroups.options",
                    v-bind:taggable="true",
                    v-bind:multiple="true",
                    v-bind:limit="2",
                    @update="updateEmailGroupSelected"
                    )
            span.col-xs-12.no_pad.row_space--xxs.clearfix.actionReminding(v-else)
              | You need to have at least 1 valid email group to set email action
            span.col-xs-12.no_pad.row_space--xxs.clearfix.SMS(v-if="emailGroups.options.length !== 0")
              .fa_checkbox
                input(type="checkbox" value='SMS' id="SMS" v-model='newActions' v-bind:checked.once="editing.actionKeys.indexOf('SMS') !== -1")
                label(for="SMS" v-on:click.prevent="clickGroups('SMS')") SMS
              span.no_pad.col-xs-12.row_space--xxs(v-if="newActions.indexOf('SMS') !== -1")
                  v-select(
                    v-bind:selected="SMSGroups.selected",
                    v-bind:show-labels="true",
                    v-bind:options="SMSGroups.options",
                    v-bind:taggable="true",
                    v-bind:multiple="true",
                    v-bind:limit="2",
                    @update="updateSMSGroupSelected"
                    )
            span.col-xs-12.no_pad.row_space--xxs.clearfix.actionReminding(v-else)
              | You need to have at least 1 valid SMS group to set SMS action
  modal.popout.group_config(
    v-bind:title='editingGroup.title'
    v-bind:show.sync='showGroupConfigTable'
    effect='zoom'
    v-bind:callback='editingGroup.cb'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-body.clearfix(slot="modal-body")
      .col-md-6.row_space--xxs
        label Group Name
        br
        span.hint
          |(Use a name different from other group)
        validator(name='groupName')
          input.form-control(v-model="editingGroup.data.name" maxLength='7' v-validate:name="['engAndNum']")
          span.error(v-show='$groupName.name.invalid && $groupName.name.modified')
            |English characters , numbers and '_' only
      .col-md-6.row_space--xxs
        label Group Accouts
        br
        span.hint
          |({{editingGroup.format}})
        textarea(v-model='editingGroup.data.accounts' placeholder="Please use ';' to separate multiple accounts. Empty to disable this group." rows='8').form-control
</template>

<script>
import { modal, tabset, tab } from 'vue-strap'
import _ from 'lodash'
// import select from 'src/components/Multi-Select.vue'
import Multiselect from '../../components/multiselect/Multiselect.vue'
import singleSelect from 'src/components/Single-Select.vue'
import { call } from 'src/Service.js'
import singleBank from 'src/components/Single-Banks.vue'
import multiBanks from 'src/components/Multi-Banks.vue'
import { validate as validEmail } from 'email-validator'
import $ from 'jquery'

export default {
  components: {
    modal,
    tab,
    'tabs': tabset,
    'v-select': Multiselect,
    'v-single-select': singleSelect,
    'v-bank': singleBank,
    'v-multi-banks': multiBanks
  },
  data () {
    return {
      DIs: {},
      DOs: {},
      showGroupConfig: false,
      showGroupConfigTable: false,
      editingGroup: {
        _id: '',
        format: '',
        title: '',
        data: {},
        cb: () => {}
      },
      editing: {
        title: 'Event Config',
        index: '',
        newEvent: {
          name: '',
          enabled: '',
          key: '',
          condition: '=',
          value: '',
          newSource: ''
        },
        actionKeys: [],
        newActions: []
      },
      // ======== options for v-bank ===========
      conditions: [
        {label: '=', value: '='}
      ],
      eventOptions: [
        {label: 'DI', value: 'DI'}
      ],
      eventValueOptions: [
        {label: 'From Off to On', value: 'Low2High'},
        {label: 'From On to Off', value: 'High2Low'}
      ],
      events: {},
      showModal: false,
      newActions: [],
      actions: {
        high: {
          action: 'DO High',
          targets: []
        },
        low: {
          action: 'DO Low',
          targets: []
        }
      },
      // for event config to select
      emailGroups: {
        selected: [],
        options: []
      },
      // for event config to select
      SMSGroups: {
        selected: [],
        options: []
      },
      // for email config table
      emailData: {},
      // for SMS config table
      SMSData: {},
      singleNumberValid: false
    }
  }, // close data
  computed: {
    sourceOptions () {
      let options = []
      for (let key in this.DIs) {
        options.push({
          label: `[DI${key}] ` + this.DIs[key].name,
          value: `${key}`
        })
      }
      return options
    },
    targetOptions () {
      let options = []
      for (let key in this.DOs) {
        options.push({
          label: `[DO${key}]` + this.DOs[key].name,
          value: `${key}`
        })
      }
      return options
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    return call(mac, 'dxGetDIOStatus').then(({channels}) => {
      this.DIs = channels.DIs
      this.DOs = channels.DOs
      return call(mac, 'dxGetEvents')
    })
    .then(({entries}) => {
      this.events = _.cloneDeep(entries)
      return call(mac, 'dxGetEmailGroups')
    })
    .then(({entries}) => {
      for (let key in entries) {
        if (entries[key].accounts.length !== 0) { // only take the group with accounts as a option
          this.emailGroups.options.push(entries[key].name)
        }
      }
      this.emailData = _.cloneDeep(entries)
      return call(mac, 'dxGetSMSGroups')
    })
    .then(({entries}) => {
      for (let key in entries) {
        if (entries[key].accounts.length !== 0) { // only take the group with accounts as a option
          this.SMSGroups.options.push(entries[key].name)
        }
      }
      this.SMSData = _.cloneDeep(entries)
    })
    .catch(err => {
      this.alert('danger', 'Error', err.message)
    })
  },
  methods: {
    clickGroups (which) {
      let group = which === 'Email' ? this.emailGroups : this.SMSGroups

      if (this.newActions.indexOf(which) === -1) {
        this.newActions.push(which)
        group.selected = [group.options[0]]
      } else {
        this.newActions.splice(this.newActions.indexOf(which), 1)
        group.selected = []
      }
    },
    updateEmailGroupSelected (value) {
      this.emailGroups.selected = value
    },
    updateSMSGroupSelected (value) {
      this.SMSGroups.selected = value
    },
    actionTranslator (action) {
      if (action === 'DO High') {
        return 'Turn On'
      } else if (action === 'DO Low') {
        return 'Turn Off'
      } else {
        return action
      }
    },
    isString (param) {
      return typeof param === 'string'
    },
    eventTranslator (event) {
      if (event === 'Low2High') {
        return 'Turn On'
      } else if (event === 'High2Low') {
        return 'Turn Off'
      } else return event
    },
    returnEventName (event) {
      let str = ''
      if (event.key === 'DI') {
        str += `${event.key} ` + `${event.source} ` + `${this.eventTranslator(event.value)}`
      }
      return str
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    toShowModal (key) {
      this.editing.title = 'Event Config ' + key
      this.editing.index = key
      this.editing.event = _.cloneDeep(this.events[key])
      let newE = this.editing.newEvent
      let oldE = this.editing.event
      newE.key = oldE.event.key
      newE.name = oldE.name
      newE.enabled = oldE.enabled
      newE.newSource = oldE.event.source
      switch (newE.key) {
        case 'DI':
          newE.value = oldE.event.value
          break
      }
      this.editing.actionKeys = this.editing.event.actions.map((obj) => {
        return obj.action
      })
      this.newActions = this.editing.actionKeys
      for (let obj in this.editing.event.actions) {
        switch (this.editing.event.actions[obj].action) {
          case 'DO High':
            this.actions.high.targets = this.editing.event.actions[obj].targets
            break
          case 'DO Low':
            this.actions.low.targets = this.editing.event.actions[obj].targets
            break
          case 'SMS':
            this.SMSGroups.selected = _.cloneDeep(this.editing.event.actions[obj].targets)
            break
          case 'Email':
            this.emailGroups.selected = _.cloneDeep(this.editing.event.actions[obj].targets)
            break
        }
      }
      this.showModal = true
    },
    hasSource () {
      // check newSource here
      return this.editing.newEvent.newSource && this.editing.newEvent.newSource.length !== 0
    },
    hasEventValue () {
      // check Event Value exist and valid
      let newE = this.editing.newEvent
      let value = false
      switch (newE.key) {
        case 'DI':
          value = newE.value && typeof newE.value === 'string'
          break
      }
      return value
    },
    hasAction () {
      if (this.newActions && this.newActions.length !== 0) {
        return true
      } else {
        return false
      }
    },
    hasValidPowerTypeAction () {
      let counter = 0
      for (let i = 0; i < this.newActions.length; i++) {
        if (this.newActions[i] !== 'Email' && this.newActions[i] !== 'SMS') counter = counter + 1
      }
      return counter <= 1
    },
    hasTarget () {
      // check Target exist and valid
      let newAc = this.newActions
      let ac = this.actions
      if (newAc.indexOf('DO High') !== -1 && ac.high.targets.length === 0) return false
      if (newAc.indexOf('DO Low') !== -1 && ac.low.targets.length === 0) return false
      if (newAc.indexOf('Email') !== -1 && this.emailGroups.selected.length === 0) return false
      if (newAc.indexOf('SMS') !== -1 && this.SMSGroups.selected.length === 0) return false
      return true
    },
    hasConflictActionOnSameTarget (param) {
      let actionMap = {}
      param.entries[this.editing.index].actions.map(cur => {
        actionMap[cur.action] = cur.targets
      })
      let keys = Object.keys(actionMap)

      // has none conflict
      if (!(keys.indexOf('DO High') !== -1 && keys.indexOf('DO Low') !== -1)) return false

      // check target
      for (let highTar of actionMap['DO High']) {
        for (let lowTar of actionMap['DO Low']) {
          if (highTar === lowTar) return true
        }
      }
    },
    handleEventConfig () {
      // event name validation
      if (!this.$eventName.valid || this.editing.newEvent.name.trim().length === 0) {
        return this.alert('danger', '', 'Please enter a valid event name')
      }

      // event need a source except 'Connection'
      if (!this.hasSource()) {
        return this.alert('danger', '', 'Please give this event a source')
      }

      // event need a value
      if (!this.hasEventValue()) return this.alert('danger', '', 'Please give your event a value')

      // event need at least one action
      if (!this.hasAction()) return this.alert('danger', '', 'Please give your config an action')

      // event need a target
      if (!this.hasTarget()) return this.alert('danger', '', 'Please give your action a target')

      let newEvent = this.editing.newEvent
      let ac = []

      // ============ to pack actions
      for (let action of this.newActions) {
        switch (action) {
          case 'DO High':
            ac.push({
              action: action,
              targets: this.actions.high.targets
            })
            break
          case 'DO Low':
            ac.push({
              action: action,
              targets: this.actions.low.targets
            })
            break
          case 'SMS':
            ac.push({
              action: action,
              targets: this.SMSGroups.selected
            })
            break
          case 'Email':
            ac.push({
              action: action,
              targets: this.emailGroups.selected
            })
            break
        }
      }

      // start to pack
      let param = {
        entries: {
          [this.editing.index]: {
            enabled: newEvent.enabled,
            name: newEvent.name.trim(), // trim the ' ' of both sides
            event: {
              key: newEvent.key,
              condition: newEvent.condition,
              value: '',
              source: newEvent.newSource
            },
            actions: ac
          }
        }
      } // close param

      if (this.hasConflictActionOnSameTarget(param)) return this.alert('danger', '', 'You can not set conflict action to same target')

      // ============= different key, pack different event
      switch (newEvent.key) {
        case 'DI':
          param.entries[this.editing.index].event.value = newEvent.value
          break
      }

      // validation function
      function isEventEqual (a, b) {
        return a.condition === b.condition && a.key === b.key && a.source === b.source && a.value === b.value
      }

      function isActionConflict (a, b) {
        let hasConflictAction = false
        let hasSameTarget = false

        // Compare actions
        for (let aKey of Object.keys(a.actions)) {
          for (let bKey of Object.keys(b.actions)) {
            let aAc = a.actions[aKey]
            let bAc = b.actions[bKey]
            if (aAc.action === 'DO High' && bAc.action === 'DO Low' || aAc.action === 'DO Low' && bAc.action === 'DO High') {
              hasConflictAction = true

              // Compare targets
              for (let tar of aAc.targets) {
                if (bAc.targets.indexOf(tar) !== -1) {
                  hasSameTarget = true
                  break
                }
              }
              break
            }
          }
        }
        return hasConflictAction && hasSameTarget
      }

      let conflict = []
      let keys = Object.keys(this.events)
      // push same action, same event and same target to toCheckEvt
      for (let k of keys) {
        let evt = this.events[k]
        if (isEventEqual(evt.event, param.entries[this.editing.index].event) && isActionConflict(evt, param.entries[this.editing.index]) && parseInt(this.editing.index) !== parseInt(k)) conflict.push(k)
      }
      if (conflict.length > 0) return this.alert('danger', '', `You have set conflict action with Event ${conflict.join(',')}`)

      console.log('hi everything is fine')

      call(this.$route.params.mac, 'dxSetEvents', param).then(res => {
        console.log(res)
        this.showModal = false
      }, err => {
        console.log(err)
      })
    },
    setEvent (enabled, eventKey) {
      let param = {
        entries: {
          [eventKey]: this.events[eventKey]
        }
      }
      param.entries[eventKey].enabled = enabled
      call(this.$route.params.mac, 'dxSetEvents', param).then(res => {
        console.log(res)
      }, err => {
        this.alert('danger', 'Unexpected Error', err)
        console.log(err)
      })
    },
    handleGroupConfig (type, key) {
      console.log(key)

      if (type === 'email') {
        this.editingGroup._id = key
        this.editingGroup.title = 'Edit email group ' + key
        this.editingGroup.format = 'ex1@gmail.com;ex2@gmail.com'
        this.editingGroup.data = _.cloneDeep(this.emailData[key])
        this.editingGroup.cb = this.emailGpApply
      } else if (type === 'SMS') {
        this.editingGroup._id = key
        this.editingGroup.title = 'Edit SMS group ' + key
        this.editingGroup.format = '+886932123123;+886972456456'
        this.editingGroup.data = _.cloneDeep(this.SMSData[key])
        this.editingGroup.cb = this.SMSGpApply
      }
      this.showGroupConfigTable = true
    },
    checkGroupNameUsed (type) {
      // check if new name is used in this.emailData or this.SMSData
      let data = type === 'email' ? this.emailData : this.SMSData
      for (let key in data) {
        if (key !== this.editingGroup._id && data[key].name === this.editingGroup.data.name) return true
      }
      return false
    },
    checkGroupAccountAvailable (type) {
      // empty would be disable, so let it pass
      if (this.editingGroup.data.accounts.length === 0) {
        return true
      } else {
        let accounts = this.editingGroup.data.accounts.split(';')
        // 怎麼樣回傳都是array ,如果source 裡面沒有';',then will return an array with only one value

        if (type === 'email') {
          for (let email of accounts) {
            if (!validEmail(email)) return 'one of the emails invalid' // single email invalid
          }
        } else if (type === 'SMS') {
          let regex = /^\+{1}[0]{0,1}\d{10,12}/
          for (let number of accounts) {
            if (!regex.test(number)) return 'one of the number invalid' // single number invalid
          }
        }

        return true
      }
    },
    checkGroupAccountOverLimit () {
      return this.editingGroup.data.accounts.split(';').length > 10
    },
    checkGroupCanBeEmpty (type) {
      // 1. Find the editing name as key
      let oldName = type === 'Email' ? this.emailData[this.editingGroup._id].name : this.SMSData[this.editingGroup._id].name
      let newName = this.editingGroup.data.name

      if (oldName === newName) return true

      // 2. Check whether the key is being used in this.events.actions
      for (let key of Object.keys(this.events)) {
        for (let obj of this.events[key].actions) {
          if (obj.action === type && obj.targets.indexOf(oldName) !== -1) return false
        }
      }
      return true
    },
    emailGpApply () {
      // validation
      // 0. check name is vaild
      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name')
      // 1. check if group name is available
      if (this.checkGroupNameUsed('email')) return this.alert('danger', '', 'Group name used')

      // 2. check if this group is being used in any action of this.events
      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('Email')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty')
      }

      if (!this.checkGroupCanBeEmpty('Email')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name')
      }

      // 3. check if accoutAvailable
      if (typeof this.checkGroupAccountAvailable('email') === 'string') {
        return this.alert('danger', '', this.checkGroupAccountAvailable('email'))
      }

      // 4. check if the amount of the accounts is over limit
      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed')

      console.log('hahaha all email good')

      // update the targets name in each event target
      let preName = this.emailData[this.editingGroup._id].name
      let newName = this.editingGroup.data.name
      let newEvents = _.cloneDeep(this.events)
      console.log('preName = ', preName)
      console.log('newName = ', newName)

      for (let key of Object.keys(newEvents)) {
        for (let obj of newEvents[key].actions) {
          if (obj.action === 'Email' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
            obj.targets[obj.targets.indexOf(preName)] = newName
          }
        }
      }

      // remove the ' ' from both sides of the string
      this.editingGroup.data.name = this.editingGroup.data.name.trim()
      // update the root object to activate the Vue to update view
      this.events = newEvents

      // update the group to server
      let param = {
        entries: {
          [this.editingGroup._id]: this.editingGroup.data
        }
      }
      console.log(param)

      call(this.$route.params.mac, 'dxSetEmailGroups', param).then(res => {
        this.showGroupConfigTable = false
      }, err => {
        this.alert('danger', '', err)
      })
    },
    SMSGpApply () {
      // validation
      // 0. check name is vaild
      if (this.$groupName.invalid) return this.alert('danger', '', 'Invalid group name')

      // 1. check if group name is available
      if (this.checkGroupNameUsed('SMS')) return this.alert('danger', '', 'Invalid group name')

      // 2. check if this group is being used in any action of this.events
      if (this.editingGroup.data.accounts.length === 0 && !this.checkGroupCanBeEmpty('SMS')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before leaving it empty')
      }

      if (!this.checkGroupCanBeEmpty('SMS')) {
        return this.alert('danger', '', 'You need to remove this group out of the targets of all events before modifying the name')
      }

      // 3. check if accoutAvailable
      if (typeof this.checkGroupAccountAvailable('SMS') === 'string') {
        return this.alert('danger', '', this.checkGroupAccountAvailable('SMS'))
      }

      // 4. check if the amount of the accounts is over limit
      if (this.checkGroupAccountOverLimit()) return this.alert('danger', '', 'Only 10 accounts allowed')

      console.log('hahah all number good')

      // update the targets name in each event target
      let preName = this.SMSData[this.editingGroup._id].name
      let newName = this.editingGroup.data.name
      let newEvents = _.cloneDeep(this.events)

      for (let key of Object.keys(newEvents)) {
        for (let obj of newEvents[key].actions) {
          if (obj.action === 'SMS' && preName !== newName && obj.targets.indexOf(preName) !== -1) {
            obj.targets[obj.targets.indexOf(preName)] = newName
          }
        }
      }

      // remove the ' ' from both sides of the string
      this.editingGroup.data.name = this.editingGroup.data.name.trim()
      // update the root object to activate the Vue to update view
      this.events = newEvents

      // start to update the group to server
      let param = {
        entries: {
          [this.editingGroup._id]: this.editingGroup.data
        }
      }
      console.log(param)
      call(this.$route.params.mac, 'dxSetSMSGroups', param).then(res => {
        this.showGroupConfigTable = false
      }, err => {
        this.alert('danger', '', err)
      })
    },
    handleDeleteGroup (group, tag) {
      let key = this[group].selected.indexOf(tag)
      this[group].selected.splice(key, 1)
    }
  },
  ready () {
  },
  watch: {
    params: 'reloadAsyncData',
    showModal (nv) {
      if (!nv) {
        $('.event_config').scrollTop(0)
      }
    },
    showGroupConfigTable (nv) {
      if (!nv) {
        $('.group_config').scrollTop(0)
      }
    },
    emailGroups: {
      deep: true,
      handler: function (nv) {
        if (nv.selected.length === 0 && this.newActions.indexOf('Email') !== -1) {
          this.newActions.splice(this.newActions.indexOf('Email'), 1)
        }
      }
    },
    SMSGroups: {
      deep: true,
      handler: function (nv) {
        if (nv.selected.length === 0 && this.newActions.indexOf('SMS') !== -1) {
          this.newActions.splice(this.newActions.indexOf('SMS'), 1)
        }
      }
    }
  },
  events: {
    update (mac, {type, event, msg}) {
      // update the data when received
      if (type === 'event') {
        this.events = _.assignIn(this.events, event)
      } else if (type === 'Email') {
        this.emailData = _.assignIn(this.emailData, event)
        // update the emailGroups
        this.emailGroups = {
          options: [],
          selected: []
        }
        for (let key in this.emailData) {
          if (this.emailData[key].accounts.length !== 0) {
            this.emailGroups.options.push(this.emailData[key].name)
          }
        }
      } else if (type === 'SMS') {
        this.SMSData = _.assignIn(this.SMSData, event)
        // update the SMSGroups
        this.SMSGroups = {
          options: [],
          selected: []
        }
        for (let key in this.SMSData) {
          if (this.SMSData[key].accounts.length !== 0) {
            this.SMSGroups.options.push(this.SMSData[key].name)
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  table th {
    text-align: center;

  }
  .config_switch{
    padding: 3px 6px;
  }
  .event_table{
    text-align: center;
  }
  .event_mobile_table{
    text-align: center;
  }
  .function_group{
    padding-top: $space_sm;
    padding-bottom: $space_sm;
    @include breakpoint(xs){
      padding-top: $space_xxs;
      padding-bottom: $space_xxs;
    }
  }
  /* ================= pc table ================ */
  .event_table{
    td.source{
      min-width: 100px;
      white-space: nowrap;
    }
    .source > div{
      span{
        border-radius: $base_border_radius;
        padding: 5px 7px;
        color: $GLOBAL_tag_fg;
        background-color: $GLOBAL_tag_bg;
        border: 1px solid $GLOBAL_tag_border;
        // @each $i in $window_colors{
        //   &[data-bgColor='#{nth($i, 1)}']{
        //     background-color: #{nth($i, 2)}
        //   }
        // }
      }
    }
    td.action{
      .action__single{
        padding: 7px;
      }
      .action_content{
        padding-bottom: 7px;
      }
      .action_target{
        padding: 5px 7px;
        border-radius: $base_border_radius;
        color: $GLOBAL_tag_fg;
        background-color: $GLOBAL_tag_bg;
        border: 1px solid $GLOBAL_tag_border;
        // @each $i in $window_colors{
        //   &[data-bgColor='#{nth($i, 1)}']{
        //     background-color: #{nth($i, 2)}
        //   }
        // }
      }
      .action_tags{
        color: $GLOBAL_tag_fg;
        background-color: $GLOBAL_tag_bg;
        border: 1px solid $GLOBAL_tag_border;

        border-radius: $base_border_radius;
        padding: 3px 5px;
        position: relative;
        & .fa{
          cursor: pointer;
          font-size: 14px;
          padding-left: 5px;
        }
      }
    }

  }
  /* =============== config table =============== */
  .event_config_table{
    th {
      text-transform: capitalize;
      text-align: center;
      font-size: 14px;
      @include breakpoint(iFive){
        padding: 5px;
      }
    }
    .fa_checkbox{
      font-size: 14px;
      @include breakpoint(md){
        font-size: 16px;
      }
      @include breakpoint(lg){
        font-size: 16px;
      }
    }
    /* ============ global weekDay and outlets style ==================== */
    .actions, .source{
      width: 100%;
      position: relative;
      span{
        float: left;
        font-size: 10px;
        padding-left: 5px;
        text-transform: capitalize;
      }
      label{
        cursor: pointer;
      }
    }
    /* =========== email_group ===================*/
    .email_group,.SMS_group{
      margin-top: -38px;
      & .btn{
        padding: 3px;
      }
    }
    /* =========== source ======================= */
    .source{
      & span:first-child .bank_checkbox:checked + .bank_label{
        background-color: $input_red;
      }
      & span:nth-child(2) .bank_checkbox:checked + .bank_label{
        background-color: $bank_blue;
      }
      & span:nth-child(3) .bank_checkbox:checked + .bank_label{
        background-color: $bank_green;
      }
      & span:last-child .bank_checkbox:checked + .bank_label{
        background-color: $bank_yellow;
      }

    }
    .bank_checkbox{
      position: absolute;
      left: -9999px;
    }

    /* =========== weekDay ================== */
    .action_checkbox{
      position: absolute;
      left: -9999px;
      &:checked + .action_label{
        background-color: $base_black;
      }
    }
    .action_label,.bank_label{
      width: 100%;
      text-align: center;
      padding: 5px 3px;
      background-color: #d8d8d8;
      color: $base_white;
    }
    .form-control{
      font-size: 12px;
    }
    .tag_group{
      .tag__single{
        border: 1px solid $pri_gray;
        border-radius: $base_border_radius;
        padding: 3px 5px;
        position: relative;
        margin-bottom: 3px;
        margin-right: 3px;
        & .fa{
          cursor: pointer;
          font-size: 14px;
          padding-left: 5px;
        }
      }
    }

    .sequence_on, .sequence_off {
      input[type='number']{
        border: 1px solid $base_gray;
      }
    }

    .enabled {
      position: relative;
      input {
        position: absolute;
        left: -9999px;
      }
      label{
        cursor: pointer;
        padding-left: 25px;
      }
      .fa{
        position: absolute;
        left: 10px;
        top: 11px;
      }
    }

    .actions span.actionReminding {
      color: #f00;
      font-size: 10px;
      text-transform: initial;
    }

  } /* close event_config_table */

  /* ============ group_editing_section ============== */
  .group_editing_section{
    table {
      text-align: center;
    }
  }
  .group_config{
    & .hint{
      font-size: 12px;
      opacity: .7;
    }
  }
  /* float styles and sequence values*/
  .float_value, .sequence_on .delay, .sequence_off .delay{
    & input[type=number]::-webkit-inner-spin-button,
      & input[type=number]::-webkit-outer-spin-button{
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
      }
      & input[type=number]{
        -moz-appearance: textfield;
      }
  }

</style>



// WEBPACK FOOTER //
// Event.vue?2dae2a07